import { BRANCO, TEXTO, CINZA_ESC, BORDA, RAIO, ESP, SOMBRA, TIPO } from "../tema";

// Cartão do painel.
//
// Ganhou cabeçalho opcional porque quase toda tela repetia o mesmo bloco à
// mão: título em negrito, uma linha de explicação embaixo e um botão à
// direita. Escrito em cada lugar, cada lugar acabava com um tamanho de
// fonte e um espaçamento ligeiramente diferente.
//
// Quem já passa só `children` continua funcionando igual: o cabeçalho não
// aparece se não houver título.
export default function Card({ titulo, sub, acao, children, style = {} }) {
  const temCabecalho = titulo || acao;
  return (
    <div style={{
      background: BRANCO,
      border: `1px solid ${BORDA}`,
      borderRadius: RAIO.lg,
      boxShadow: SOMBRA.cartao,
      padding: "22px 24px",
      ...style,
    }}>
      {temCabecalho && (
        <div style={{
          display: "flex", alignItems: "flex-start", justifyContent: "space-between",
          gap: ESP.md, flexWrap: "wrap", marginBottom: sub ? ESP.md : ESP.lg,
        }}>
          <div style={{ minWidth: 0 }}>
            {titulo && <div style={{ ...TIPO.secao, color: TEXTO }}>{titulo}</div>}
            {sub && <div style={{ ...TIPO.apoio, color: CINZA_ESC, marginTop: ESP.xs }}>{sub}</div>}
          </div>
          {acao && <div style={{ display: "flex", gap: ESP.sm, alignItems: "center" }}>{acao}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
